import { render } from "./ServiceCard.vue?vue&type=template&id=3a9144b9&scoped=true"
import script from "./ServiceCard.vue?vue&type=script&lang=js"
export * from "./ServiceCard.vue?vue&type=script&lang=js"

import "./ServiceCard.vue?vue&type=style&index=0&id=3a9144b9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a9144b9"

export default script